import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("D:/DevOps-Agents/DO-Agent2/_work/1943/s/Ifen.IfenCatalog.Nuxt/app/layouts/default.vue").then(m => m.default || m))
}